import { DirectiveOptions } from 'vue';
// import { SegmentWrapper } from './segment';

export const TrackClick: DirectiveOptions = {
  bind(el, binding) {
    el.addEventListener('click', () => {
      console.log('TrackClick', binding.value);
      // SegmentWrapper.elementClicked(binding.value);
      if (window) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'track_click',
          track_click_name: binding.value,
        });
      }
    });
  },
};
